import {
  Component,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModelsWrapperComponent } from '@app/pages/quote/standard-quote/models/models-wrapper.component';

@Component({
  selector: 'app-models-mobile',
  templateUrl: './models-mobile.component.html',
  styleUrls: ['./models-mobile.component.scss'],
})
export class ModelsMobileComponent extends ModelsWrapperComponent {
  constructor(
    route: ActivatedRoute,
  ) {
    super(route);
  }
}
